<script setup>
//https://www.youtube.com/watch?v=9ayK5ainiPo
// https://codepen.io/ahaywood/pen/eYBKYVb
const props = defineProps({
	color: String,
	perc: Number,
})
</script>

<template >
	<svg
		width="469"
		height="469"
		viewBox="0 0 215.74 215.73999"
		xmlns="http://www.w3.org/2000/svg">
		<circle
			v-if="perc"
			cx="-107.86974"
			cy="107.86994"
			r="100"
			fill="none"
			stroke-width="15"
			:stroke="`rgb(var(--color-fuchsia) / 1)`"
			:stroke-dasharray="`${perc / 100 * 628.32} , 628.32`"
			transform="rotate(-90)"
		/>
		<path
			d="m 107.87,162.47944 c 30.16011,0 54.60944,-24.44933 54.60944,-54.60944 0,-30.160113 -24.44933,-54.609442 -54.60944,-54.609442 -30.160112,0 -54.609443,24.449329 -54.609443,54.609442 0,30.16011 24.449331,54.60944 54.609443,54.60944 z"
			:fill="`rgb(var(--color-${color}) / 1)`"
			style="stroke-width:6.82618"
		/>
	</svg>
</template>